import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import IconButton from "@mui/material/IconButton";
import { FaTimes } from "react-icons/fa";
import axios from "axios";
import BtnLoader from "Components/Common/Loader/BtnLoader";
import { maxHeight } from "@mui/system";
import Swal from "sweetalert2";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: 500,
  bgcolor: "background.paper",
  border: "none",
  borderRadius: 8,
  boxShadow: 24,
  p: 4,
  maxHeight: "90vh",
  overflowY: "auto",
};

const CreateEditGangTarget = ({
  open,
  handleClose,
  fetchGangTargets,
  editData = null, // null → create mode, object → edit
}) => {
  const isEditMode = Boolean(editData);

  const [isLoading, setIsLoading] = useState(false);

  const [formData, setFormData] = useState({
    targetType: "Daily",

    activeHours: {
      hoursPerDay: 0,
      rankPoints: 0,
    },
    games: {
      gamesPerDay: 0,
      rankPoints: 0,
    },
    giftCoins: {
      giftCoinsPerDay: 0,
      rankPoints: 0,
    },

    isActive: false,
    // activeFrom: "",
    // activeTill: "",
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  // Pre-fill fields during EDIT
  useEffect(() => {
    if (editData) {
      setFormData({
        ...editData,
        activeFrom: editData.activeFrom
          ? editData.activeFrom.substring(0, 10)
          : "",
        activeTill: editData.activeTill
          ? editData.activeTill.substring(0, 10)
          : "",
      });
    }
  }, [editData]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name.includes(".")) {
      // Handle nested object (e.g. activeHours.hoursPerDay)
      const [parent, child] = name.split(".");
      setFormData((prev) => ({
        ...prev,
        [parent]: {
          ...prev[parent],
          [child]: value,
        },
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      }));
    }
  };

  const validateForm = () => {
    const f = formData;

    // 1. Target Type required
    if (!f.targetType) return "Target Type is required";

    // 2. Active Hours
    if (!f.activeHours.hoursPerDay || f.activeHours.hoursPerDay <= 0)
      return "Hours Per Day must be greater than 0";

    if (!f.activeHours.rankPoints || f.activeHours.rankPoints <= 0)
      return "Rank Points must be greater than 0";

    // 3. Games
    if (!f.games.gamesPerDay || f.games.gamesPerDay <= 0)
      return "Games Per Day must be greater than 0";

    if (!f.games.rankPoints || f.games.rankPoints <= 0)
      return "Rank Points must be greater than 0";

    // 4. Gift Coins
    if (!f.giftCoins.giftCoinsPerDay || f.giftCoins.giftCoinsPerDay <= 0)
      return "Coins Per Day must be greater than 0";

    if (!f.giftCoins.rankPoints || f.giftCoins.rankPoints <= 0)
      return "Gift Coins - Rank Points must be greater than 0";

    return null; // VALID
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationError = validateForm();
    if (validationError) {
      setError(validationError);
      return;
    }
    setIsLoading(true);
    setError("");
    setSuccess("");

    try {
      const url = isEditMode
        ? `${process.env.REACT_APP_API_URL}/gang-targets/update/${editData._id}`
        : `${process.env.REACT_APP_API_URL}/gang-targets/create`;

      const method = isEditMode ? "put" : "post";

      const response = await axios({
        method,
        url,
        headers: { "Content-Type": "application/json" },
        data: formData,
      });

      fetchGangTargets();
      handleClose();
      Swal.fire({
        icon: "success",
        title: `Gang Target ${isEditMode ? "Updated" : "Created"}`,
        text: `Gang Target ${isEditMode ? "updated" : "created"} successfully`,
        timer: 2000,
        showConfirmButton: true,
      });
    } catch (err) {
      console.log(err);
      setError("Something went wrong. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style}>
        <IconButton
          onClick={handleClose}
          sx={{ position: "absolute", right: 8, top: 8, color: "#c51369" }}
        >
          <FaTimes />
        </IconButton>

        <form onSubmit={handleSubmit} className="space-y-6">
          <h2 className="mb-2 text-center text-2xl font-bold text-navy-700">
            {isEditMode ? "Edit Gang Target" : "Create Gang Target"}
          </h2>

          {/* Target Type */}
          <div>
            <label className="mb-1 block text-lg text-navy-700">
              Target Type
            </label>
            <select
              name="targetType"
              value={formData.targetType}
              onChange={handleChange}
              className="w-full rounded-md border p-2 focus:ring-2 focus:ring-[#c51369]"
            >
              <option value="Daily">Daily</option>
              <option value="Weekly">Weekly</option>
              <option value="Monthly">Monthly</option>
            </select>
          </div>

          {/* ACTIVE HOURS */}
          <div className="rounded-lg border p-3">
            <h3 className="mb-2 font-semibold">Active Hours</h3>

            <div className="flex space-x-4">
              <div className="flex-1">
                <label>Hours Per Day</label>
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  onInput={(e) =>
                    (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                  }
                  name="activeHours.hoursPerDay"
                  value={formData.activeHours.hoursPerDay}
                  onChange={handleChange}
                  className="w-full rounded-md border p-2"
                />
              </div>
              <div className="flex-1">
                <label>Rank Points</label>
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  onInput={(e) =>
                    (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                  }
                  name="activeHours.rankPoints"
                  value={formData.activeHours.rankPoints}
                  onChange={handleChange}
                  className="w-full rounded-md border p-2"
                />
              </div>
            </div>
          </div>

          {/* GAMES */}
          <div className="rounded-lg border p-3">
            <h3 className="mb-2 font-semibold">Games</h3>

            <div className="flex space-x-4">
              <div className="flex-1">
                <label>Games Per Day</label>
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  onInput={(e) =>
                    (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                  }
                  name="games.gamesPerDay"
                  value={formData.games.gamesPerDay}
                  onChange={handleChange}
                  className="w-full rounded-md border p-2"
                />
              </div>
              <div className="flex-1">
                <label>Rank Points</label>
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  onInput={(e) =>
                    (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                  }
                  name="games.rankPoints"
                  value={formData.games.rankPoints}
                  onChange={handleChange}
                  className="w-full rounded-md border p-2"
                />
              </div>
            </div>
          </div>

          {/* GIFT COINS */}
          <div className="rounded-lg border p-3">
            <h3 className="mb-2 font-semibold">Gift Coins</h3>

            <div className="flex space-x-4">
              <div className="flex-1">
                <label>Coins Per Day</label>
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  onInput={(e) =>
                    (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                  }
                  name="giftCoins.giftCoinsPerDay"
                  value={formData.giftCoins.giftCoinsPerDay}
                  onChange={handleChange}
                  className="w-full rounded-md border p-2"
                />
              </div>

              <div className="flex-1">
                <label>Rank Points</label>
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  onInput={(e) =>
                    (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                  }
                  name="giftCoins.rankPoints"
                  value={formData.giftCoins.rankPoints}
                  onChange={handleChange}
                  className="w-full rounded-md border p-2"
                />
              </div>
            </div>
          </div>

          {/* Active Status */}
          <div>
            <div className="flex items-center gap-3">
              <input
                type="checkbox"
                name="isActive"
                checked={formData.isActive}
                onChange={handleChange}
              />
              <label className="text-lg text-navy-700">Set as Active?</label>
            </div>
            <p className="text-xs italic tracking-wide text-red-500">
              (This will deactivate the currently active one)
            </p>
          </div>

          {/* Date Fields */}
          {/* <div className="grid grid-cols-2 gap-4">
            <div>
              <label>Active From</label>
              <input
                type="date"
                name="activeFrom"
                value={formData.activeFrom}
                onChange={handleChange}
                className="w-full rounded-md border p-2"
              />
            </div>
            <div>
              <label>Active Till</label>
              <input
                type="date"
                name="activeTill"
                value={formData.activeTill}
                onChange={handleChange}
                className="w-full rounded-md border p-2"
              />
            </div>
          </div> */}
          {error && <p className="text-center text-red-500">{error}</p>}
          {success && <p className="text-center text-green-500">{success}</p>}
          <button
            type="submit"
            className="flex w-full justify-center rounded-md bg-[#c51369] p-3 text-white hover:bg-[#a10f5b]"
          >
            {isLoading ? (
              <BtnLoader />
            ) : isEditMode ? (
              "Update Target"
            ) : (
              "Create Target"
            )}
          </button>
        </form>
      </Box>
    </Modal>
  );
};

export default CreateEditGangTarget;
